module.exports = __webpack_public_path__ + "static/media/mobileLogin.1b823f34.svg";